import React from 'react';

import Container from '@vromo/ui/components/Container';
import Button from '@vromo/ui/components/Button';

import { observer } from 'mobx-react-lite';
import styled from '@emotion/styled';
import { css } from 'emotion';

import JobGrid from './JobGrid';
import { Job } from 'models';
import theme from '@vromo/ui/components/theme';

const Header = styled.div`
    flex: 0;
    padding-bottom: 20px;
`;

const GridHolder = styled.div`
    border: solid 1px #e7eaec;
    flex: 1;
    border-radius: 4px;
`;

const Empty = styled.div`
    display: flex;
    flex: 1;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    color: ${theme.mediumGrey};
`;

type Props = {
    jobs: Job[];
    createJobCsv: () => void;
    loadingJobs: boolean;
};

const JobHistory = observer(({ jobs, createJobCsv, loadingJobs }: Props) => (
    <Container
        className={css`
            flex: 1;
            display: flex;
            flex-direction: column;
        `}
        title="Job History">
        <Header>
            <Button disabled={loadingJobs} onClick={createJobCsv}>
                Export Job CSV
            </Button>
        </Header>

        <GridHolder>
            {!loadingJobs && jobs.length === 0 && (
                <Empty>No results found, try adjusting your filters.</Empty>
            )}
            {!loadingJobs && jobs.length !== 0 && <JobGrid jobs={jobs} />}
        </GridHolder>
    </Container>
));

export default JobHistory;
